import * as React from "react"
import {Label} from "@/components/ui/label"
import {BranchPythonOperator,} from "@/model/Workflow";
import Editor from '@monaco-editor/react';
import {OperatorDetailProps} from "@/view/workflow/components/operatorForm/index";
import _ from "lodash";

interface PythonOperatorFormProps extends OperatorDetailProps {
    operator: BranchPythonOperator
}
const PythonBranchOperatorForm: React.FC<PythonOperatorFormProps> = (props) => {
    const {operator, readOnly} = props;

    const _onChangeCode = _.debounce((value?: string) => {
        operator.code = value ?? ""
    }, 300);

    return (
        <div className="h-full flex flex-col space-y-3">
            <div className="flex flex-col space-y-1.5 grow">
                <Label htmlFor="framework">Code</Label>

                <Editor className='grow bg-black'
                        defaultLanguage="python"
                        defaultValue={operator.code}
                        theme="dark"
                        options={{readOnly: readOnly}}
                        onChange={_onChangeCode}
                />
            </div>
        </div>
    )
}

export default PythonBranchOperatorForm
